<template lang="pug">
.social
  span.social__text.text--20 Поделитесь своими мучениями
  .social__list
    //- og:title — заголовок ссылки
    //- og:description — описание ссылки
    //- og:ifdmage — изображение для шаринга
    a.social__item(:href="fbLink", target='_blank')
      include ../assets/img/social-fb.svg
    a.social__item(:href="vkLink", target='_blank')
      include ../assets/img/social-vk.svg
    a.social__item(:href="tgLink", target='_blank')
      include ../assets/img/social-tg.svg
    a.social__item(:href="twLink", target='_blank')
      include ../assets/img/social-tw.svg

</template>

<script>
  export default {
    name: 'SocialList',
    props: {
      status: {
        type: [String, Number],
        required: true
      }
    },
    data() {
      return {
        STATUS_FAILURE: 0,
        STATUS_ZHAROV:1,
        STATUS_USMANOV: 2,
        STATUS_SUCCESS: 3,
        sostavUrl: '//www.sostav.ru/publication/pinkman-game-33309.html'
      }
    },
    computed: {
      siteURL() {
        return `${this.sostavUrl}?act=share&result=${this.status}`;
      },
      title() {
        return 'Сделай свой Digital-проект и узнай, как это больно';
      },
      image() {
        return this.images[this.status];
      },
      fbLink() {
        return `https://www.facebook.com/sharer.php?u=${this.siteURL}`;
      },
      vkLink() {
        return `https://vk.com/share.php?url=${this.siteURL}`;
      },
      tgLink() {
        return `https://telegram.me/share/url?url=${this.siteURL}&text=${this.title}`;
      },
      twLink() {
        return `https://twitter.com/share?url=${this.siteURL}&text=${this.title}`;
      }
    }
  }
</script>

<style scoped lang="stylus">
.social
  display flex
  align-items center
  justify-content center
  // flex-wrap wrap

  padding 2.1rem 3.6rem

  background: rgba(#C7DFFE, 0.89)
  clip-path: polygon(3% 0, 99% 0, 100% 97%, 0% 100%)
  @media $tablet
    padding-top 3.3rem
    padding-bottom 3.3rem
  &__list
    display flex
    align-items center
    justify-content center
    height 3.2rem
    width 100%
    max-width: 300px
    margin: auto
    @media $tablet
      max-width: 100%
      width 40%
  &__item
    display: flex
    min-width 3rem
    max-height 3rem
    height: 100%
    flex-shrink 1
    margin-right 1.5rem
    fill: #fff
    &:last-child
      margin-right 0
    svg
      width 100%
      height 100%
      display: block
      color $white
      transition color 0.3s ease
    &:hover
      svg
        color: $pink
  &__text
    margin-bottom 1rem
    font-weight 700
    letter-spacing: -0.2px
    @media $laptop
      margin-bottom 0

</style>
